// Copyright (c) Microsoft Corporation.  All rights reserved.

import * as ActionBase from "VSS/Flux/Action";

export var patTokenCreated = new ActionBase.Action<string>();